
import { computed, defineComponent, nextTick, PropType, reactive, ref, toRefs } from 'vue'
import ChevronRightIcon from '@/components/Icons/ChevronRightIcon.vue'
import ResetIcon from '@/components/Icons/ResetIcon.vue'
import { debounce } from 'lodash'
import { CtCategory, CtStockItem } from '@/models/interfaces/content-type'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'ProductSearch',
  components: { ResetIcon, ChevronRightIcon },

  props: {
    searchValue: {
      type: String,
      default: '',
    },
    categories: {
      type: Array as PropType<CtCategory[]>,
    },
    selectedCategories: {
      type: Array as PropType<CtCategory['sys']['id'][]>,
      default: () => []
    },
    categorySearch: {
      type: String as PropType<string | null>,
      default: null
    },
    brands: {
      type: Array as PropType<CtStockItem[]>,
    },
    selectedBrands: {
      type: Array as PropType<CtStockItem['brand'][]>,
      default: () => []
    },
    brandSearch: {
      type: String as PropType<string | null>,
      default: null
    },
    recentProducts: {
      type: Array
    },
    brandLimit: {
      type: Number,
      default: 5
    },
    categoryLimit: {
      type: Number,
      default: 5
    }
  },

  emits: ['update:searchValue', 'save-search-query', 'update:selected-categories', 'update:selected-brands', 'update:category-search', 'update:brand-search'],

  setup (props, { emit }) {
    const $router = useRouter()

    const state = reactive({
      active: false
    })

    const emitSearchQuery = debounce(($event) => {
      emit('update:searchValue', $event)
      state.active = true
    }, 500, { trailing: true })

    const emitCategoryId = ($event) => {
      console.log($event, [...props.selectedCategories, $event])
      if (props.selectedCategories.includes($event)) {
        void $router.replace({ query: { ...$router.currentRoute.value.query, category: $event } })
        emit('update:selected-categories', props.selectedCategories.filter(catId => catId !== $event))
        if (props.searchValue === '') state.active = false
      } else {
        emit('update:selected-categories', [...props.selectedCategories, $event])
        state.active = true
      }
    }

    const emitBrand = ($event) => {
      if (props.selectedBrands.includes($event)) {
        emit('update:selected-brands', props.selectedBrands.filter(brand => brand !== $event))
        if (props.searchValue === '') state.active = false
      } else {
        emit('update:selected-brands', [...props.selectedBrands, $event])
        state.active = true
      }
    }

    const filteredCategories = computed(() => {
      return props.categories?.filter(cat => cat.name !== null) ?? []
      // const actives = nonEmpty?.filter(cat => props.selectedCategories.includes(cat.sys.id))
      // if (actives) {
      //   return [...actives, ...nonEmpty.filter(cat => !props.selectedCategories.includes(cat.sys.id))]
      // }
      // return nonEmpty
    })

    const filteredBrands = computed(() => {
      return props.brands?.filter((brand: any) => brand.brand !== null)
    })

    const emitSaveSearchQuery = (event: KeyboardEvent, searchValue, disableKeyUpEvent) => {
      if (event.key === 'Enter' || disableKeyUpEvent) {
        emit('update:searchValue', searchValue)
        emit('save-search-query', searchValue)
      }
    }

    const resetSearch = () => {
      emit('update:searchValue', '')
      emit('update:selected-categories', [])
      emit('update:selected-brands', [])
      state.active = false
      localStorage.removeItem('previousRouteInfo')
    }

    const productRoute = (productId) => {
      void $router.push({ name: 'ProductDetailIndex', params: { productId: productId, editing: '' } })
    }

    const categorySearchInput = ref<HTMLInputElement | null>(null)
    const brandSearchInput = ref<HTMLInputElement | null>(null)

    const onSearchBtnClick = (event, searchValue, inputRef) => {
      emit(event, searchValue === null ? '' : null)
      if (searchValue === null) {
        void nextTick(() => inputRef?.focus())
      }
    }

    return {
      ...toRefs(state),
      emitSearchQuery,
      filteredCategories,
      filteredBrands,
      emitSaveSearchQuery,
      resetSearch,
      emitCategoryId,
      emitBrand,
      productRoute,
      categorySearchInput,
      brandSearchInput,
      onSearchBtnClick,
    }
  }
})
